export interface MapCameraState {
  scale: number;
  offsetX: number;
  offsetY: number;
}

// Camera is scoped per location — each sede has its own layout, so sharing a
// single pan/zoom across them would land the user on the wrong part of the
// canvas after a sede switch. Keys namespaced under ``ss_map_camera:<id>``.
function storageKey(locationId: string | null): string | null {
  if (!locationId) return null;
  return `ss_map_camera:${locationId}`;
}

/** Returns the persisted camera state for the location, or null if unset. */
export function loadCamera(locationId: string | null): MapCameraState | null {
  const key = storageKey(locationId);
  if (!key) return null;
  try {
    const raw = localStorage.getItem(key);
    if (raw) {
      return JSON.parse(raw) as MapCameraState;
    }
  } catch {}
  return null;
}

export function saveCamera(locationId: string | null, cam: MapCameraState) {
  const key = storageKey(locationId);
  if (!key) return;
  localStorage.setItem(
    key,
    JSON.stringify({
      offsetX: Math.round(cam.offsetX),
      offsetY: Math.round(cam.offsetY),
      scale: Math.round(cam.scale * 1000) / 1000,
    }),
  );
}
